import { render, staticRenderFns } from "./view.html?vue&type=template&id=5a8dd545&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style_pure.less?vue&type=style&index=0&id=5a8dd545&lang=less&scoped=true&"
import style1 from "./style_border.less?vue&type=style&index=1&id=5a8dd545&lang=less&scoped=true&"
import style2 from "./style_gradient.less?vue&type=style&index=2&id=5a8dd545&lang=less&scoped=true&"
import style3 from "./style_link.less?vue&type=style&index=3&id=5a8dd545&lang=less&scoped=true&"
import style4 from "./style_custom_toggle.less?vue&type=style&index=4&id=5a8dd545&lang=less&scoped=true&"
import style5 from "./style_custom_background.less?vue&type=style&index=5&id=5a8dd545&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8dd545",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a8dd545')) {
      api.createRecord('5a8dd545', component.options)
    } else {
      api.reload('5a8dd545', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=5a8dd545&scoped=true&", function () {
      api.rerender('5a8dd545', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/button/index.vue"
export default component.exports